import * as React from "react";
// import { IParagraphFeaturedPropertiesProps } from "./ParagraphFeaturedPropertiesProps";
import { Container } from "./ParagraphFeaturedPropertiesHelpers";
import { graphql } from "gatsby";
import FeaturedProperties from "../../common/FeaturedProperties/FeaturedProperties";
import { IFeaturedPropertiesProps } from "../../common/FeaturedProperties/FeaturedPropertiesProps";

const ParagraphFeaturedProperties: React.FC<IFeaturedPropertiesProps> = (
  props
) => {
  return (
    <Container>
      <FeaturedProperties {...props} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphFeaturedProperties on paragraph__featured_properties {
    id
    parent_type
    field_title
    description: field_description
    field_subtitle
    relationships {
      field_sites {
        machine_name
      }
      properties: field_properties {
        id
        field_description
        relationships {
          hotel: field_hotel {
            name
            path {
              alias
            }
            description
            relationships {
              field_tags {
                name
              }
            }
          }
          media: field_media {
            relationships {
              image: field_media_image {
                publicUrl
                gatsbyImage(
                  width: 640
                  height: 480
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
    }
  }
`;

export default ParagraphFeaturedProperties;
